import React from 'react'
import { Helmet } from 'react-helmet';
// import "./EventsSponsors.css"
import { EventsSponsorsData } from '../data/EventsSponsorsData';

const EventsSponsors = () => {
    return (
        <div>
            <Helmet>
                <title>Events Sponsors</title>
            </Helmet>
            <div className='main-container'>
            <div className="page-bg"></div>
        <div className="page-bg page-bg2"></div>
        <div className="page-bg page-bg3"></div>
                <div className="section">
                    <div className="page-heading">
                        <h1>Events Sponsors</h1>
                    </div>
                    <div className="card-container">
                        <div className="grid-4">
                            {/* {EventsSponsorsData.map((Sponsor, index) => {
                                return (
                                    <div className="card" key={index}
                                        style={{
                                            backgroundImage: `url(${Sponsor.Image})`,
                                            backgroundSize: "cover",
                                        }}>
                                        <div className="content">
                                            <h2 className="title">{Sponsor.Title}</h2>
                                            <p className="copy">{Sponsor.Description}</p>
                                            <button className="btn">Read More</button>
                                        </div>
                                    </div>
                                )
                            })} */}


                            {EventsSponsorsData.map((Sponsor, index) => {
                                return (
                                    <div className='card-item' key={index}>
                                        <div className="card-item-image">
                                            <img src={Sponsor.Image} alt='Events' />

                                        </div>
                                        <div className="card-item-caption">
                                            <h2>{Sponsor.Title}</h2>
                                        </div>
                                    </div>

                                )
                            })}










                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventsSponsors